/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Saturday, June 18th 2022, 1:31:54 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

interface FormOptionsSeparatorProps {
  seperatorText?: React.ReactNode;
}

export const FormOptionsSeparator = ({ seperatorText }: FormOptionsSeparatorProps) => (
  <div className="form-options-seperator">
    <div className="fo-line"></div>
    {seperatorText ? <div className="fo-text">{seperatorText}</div> : null}
    <div className="fo-line"></div>
  </div>
);
